import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import Cookies from 'react-cookies';
import { useSelector } from 'react-redux';
import { COOKIES } from '../../brands/default/constants';
import { redirectToURL } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';

const MapViewBackButton = () => {
  const theme = useContext(ThemeContext);
  const router = useRouter();
  const location = useSelector((state) => state.locations.location.shortName);

  const backToListView = () => {
    const defaultLoc = 'glasgow';
    const localPageRedirectUrl = `/deals/${location || defaultLoc}`;
    // use back path from cookie if available
    const pathFromCookie = Cookies.load(COOKIES.mapBackPath);
    redirectToURL(
      pathFromCookie ? pathFromCookie : localPageRedirectUrl,
      router,
    );
  };

  return (
    <>
      <button
        className="close-button"
        id="close-button"
        onClick={() => backToListView()}
        type="button"
      >
        ×<span className="sr-only">Close</span>
      </button>
      <style jsx>{`
        .close-button {
          background-color: ${theme.colors.background};
          border: none;
          border-radius: 50%;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
          box-sizing: border-box;
          color: ${theme.colors.black};
          cursor: pointer;
          font-size: 18px;
          height: 24px;
          line-height: 18px;
          margin-left: 15px;
          padding: 0;
          text-align: center;
          text-decoration: none;
          width: 24px;
        }
      `}</style>
    </>
  );
};

export default MapViewBackButton;
